export class RegisterUser {
    public id: number = 0;
    public email: string = '';
    public passwordStr: string = '';
    public password: string = '';
    public getNews: boolean = false;
    public captchaText: string = '';
    public selectedPositionId: number = 0;
    public isFree: boolean = false;
    public isPaidOnSignup: boolean = false;
    public isAutoActivation: boolean = false;
}